/** Parse a link and return an element */

import { shortUuid, type Embed } from '@tunasong/models'
import Services from './services/index.js'

export const parseLink = (url?: string): Embed | null => {
  for (const service of Object.values(Services)) {
    const r = service.parse(url)
    if (r) {
      return { ...r, id: shortUuid() }
    }
  }
  return null
}
